import React from 'react';
import styles from './Eyebrow.module.scss';

interface IEyebrow {
  children: React.ReactNode;
  element?: React.ComponentType | keyof JSX.IntrinsicElements;
}

export const Eyebrow = ({ children, element = 'p' }: IEyebrow) => {
  const Element = element;
  return (
    <div className={styles.root}>
      <Element className={styles.text}>{children}</Element>
      <svg className={styles.stroke} height="10" preserveAspectRatio="none" viewBox="0 0 190 10" width="190">
        <path
          d="M 3 4 C 40 6, 45 3, 95 4 S 140 6, 187 6"
          fill="transparent"
          stroke="#BEA2FF"
          strokeLinecap="round"
          strokeWidth={3}
        />
      </svg>
    </div>
  );
};
